<template>
	<div class="error-layout" v-if="show">
		<div class="error__icon">!</div>
		<div class="error__text">
			{{ text }}
		</div>
	</div>
</template>

<script>
export default {
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		text: {
			type: String,
			default: null,
		},
	},
};
</script>

<style lang="scss" scoped>
.error-layout {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;

	.error__icon {
		background: #de0a2a;
		padding: 15px 27px;
		border-radius: 50%;
		margin-bottom: 30px;
		color: white;
		font-size: 30px;
		font-weight: 700;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.error__text {
		text-align: center;
		font-size: 20px;
	}
}
</style>
